export default {
  data() {
    return {
      sendingMail: false,
    };
  },
  methods: {
    sendMail(inquiry, captcha, isReporting = false) {
      return new Promise((res, rej) => {
        if (this.isValid(inquiry, captcha, isReporting) && !this.sendingMail) {
          this.sendingMail = true;
          if (!inquiry.url) {
            inquiry.url = location.href;
          }
          if (isReporting) inquiry.isReporting = true;

          this.$http
            .post(`${process.env.VUE_APP_BASE_URI}/mail`, inquiry, {})
            .then(() => {
              this.$snotify.success(this.$t("inquiry-1"));
              res();
            })
            .catch((err) => {
              console.log(err);
              this.$snotify.error(this.$t("inquiry-2"));
              rej();
            })
            .then(() => {
              setTimeout(() => {
                this.sendingMail = false;
              }, 1000);
            });
        } else {
          rej();
        }
      });
    },
    isValid(i, c, isReporting) {
      if (!i.name && !isReporting) {
        this.$snotify.error(this.$t("inquiry-3"));
        return false;
      }
      if (!i.phone && !isReporting) {
        this.$snotify.error(this.$t("inquiry-4"));
        return false;
      }

      if (!i.email) {
        this.$snotify.error(this.$t("inquiry-5"));
        return false;
      }

      if (!i.category && !isReporting) {
        this.$snotify.error(this.$t("inquiry-6"));
        return false;
      }
      if (!i.message) {
        this.$snotify.error(this.$t("inquiry-7"));
        return false;
      }
      if (i.message.length > 100 && !isReporting) {
        this.$snotify.error(this.$t("inquiry-7-2"));
        return false;
      }
      if (!i.captchaSum) {
        this.$snotify.error(this.$t("inquiry-10"));
        return false;
      }
      if (i.captchaSum) {
        if (+c.sum !== +i.captchaSum) {
          this.$snotify.error(this.$t("inquiry-11"));
          return false;
        }
      }
      return true;
    },
  },
};
